import axios from '../requester';
import { API } from '../constants/api-urls';
import { AUTH_LEVEL, PROVIDERS_MAP } from 'common/constants/constants';
import AppRouter from 'common/AppRouter';
import { redirectToProvider } from 'common/utils/utils';
import { SENSOR_AUTH_TYPES } from './sensors.service';

export const getAuthUrl = async jira_url =>
  axios
    .get(`${API.JIRA_AUTH_PATH}/auth-url`, { params: { jira_url } })
    .then(({ auth_url }) => auth_url);

export const getAuthKeys = async (account_id, jira_url) =>
  axios.get(`${API.JIRA_AUTH_PATH}/keys`, { params: { account_id, jira_url } });
export const getState = async () => axios.get(`${API.JIRA_AUTH_PATH}/state`);
export const getAccess = async () =>
  axios.get(`${API.JIRA_AUTH_PATH}/access`, {
    params: { perform_auth_test: true }
  });
export const getConnectivityStatus = async self_hosted_uri =>
  axios
    .post(`${API.TEST_ACCESS_CONNECTIVITY_PATH}/jira`, { self_hosted_uri })
    .then(({ result }) => result);

export const connectJiraOAuth2 = (query = {}) => {
  const jiraKey = PROVIDERS_MAP.jira.provider_path;
  const redirectPath = `${AppRouter.PROJECT_MANAGEMENT.path}/${jiraKey}?isOrgSettings=true&withScopesValidations=true`;

  redirectToProvider(jiraKey, {
    redirectPath,
    query: {
      ...query,
      auth_type: SENSOR_AUTH_TYPES.OAUTH2,
      level: AUTH_LEVEL.ORGANIZATION
    }
  });
};
